import { render, staticRenderFns } from "./RowAddTask.vue?vue&type=template&id=40b640c6&"
import script from "./RowAddTask.vue?vue&type=script&lang=js&"
export * from "./RowAddTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports